import {
  ExclamationTriangleIcon,
  InformationCircleIcon,
} from '@heroicons/react/20/solid';
import {fetchSync} from '@shopify/hydrogen';
import {addOrdinalToNumber, textDate} from '../../lib/hatcherybrain';

export function AvailabilityMessage({sku}) {
  const {nextAvailableDate} = fetchSync(
    `https://apiv2.hatcherybrain.com/feed/${sku}`,
  ).json();

  if (nextAvailableDate) {
    const nextDate = textDate(nextAvailableDate);

    return (
      <div className="rounded-md bg-blue-50 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <InformationCircleIcon
              className="h-5 w-5 text-blue-400"
              aria-hidden="true"
            />
          </div>
          <div className="ml-3 flex-1 md:flex md:justify-between">
            <p className="text-md font-semibold text-blue-700">
              Hatching on {nextDate}.
            </p>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="border-l-4 border-yellow-400 bg-yellow-50 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <ExclamationTriangleIcon
              className="h-5 w-5 text-yellow-400"
              aria-hidden="true"
            />
          </div>
          <div className="ml-3">
            <p className="text-md font-semibold text-yellow-700">
              No hatches currently available
            </p>
          </div>
        </div>
      </div>
    );
  }
}
